import { Navigate, useParams } from 'react-router-dom'

export const RedirectToBaseInvest = () => {
  const params = useParams()
  return <Navigate to={`/invest/${params.ioID}`} />
}
